import { Component, OnInit, Input,SimpleChanges } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { SDTK } from '../../../../../model/quote/sdtk/sdtk.model';
import { QuoteService } from '../../../../quote.service';
import { PolicyService } from '../../../../../policy/policy.service';

@Component({
  selector: 'app-sdtk-overview',
  templateUrl: './sdtk-overview.component.html',
  styleUrls: ['./sdtk-overview.component.css']
})
export class SdtkOverviewComponent implements OnInit {

  quote;
  quoteApplicationData = new SDTK();
  CoverTo;
  proposer_type:string="";
  transction_type = '';
  policyReason: string = '';
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.quoteApplicationData = value;
      let maxDate = new Date(value.policy_start_date).setFullYear(new Date(value.policy_start_date).getFullYear() + 1);
      this.CoverTo = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      const proposerType = value.policy_holder?.proposer_type;

      if (proposerType) {
        if (proposerType == 1) {
          this.quote.policy_holder.proposer_type = 'individual';
        }
        else if (proposerType == 2) {
          this.quote.policy_holder.proposer_type = 'joint';
        }
        else {
          this.quote.policy_holder.proposer_type = 'company';
        }
        this.quote.policy_holder.proposer_type = 'individual';
      }
    }
    this.getQuoteTypes();
    this.getPolicyReasons();
  }

  constructor(private sessionSt: LocalStorageService, private quoteService: QuoteService, private policyService: PolicyService) { }
  isAdmin = false;
  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    this.proposer_type = 'Individual';
  }
    ngOnChanges(changes: SimpleChanges) {
      this.getQuoteTypes();
      this.getPolicyReasons();
    }
    getQuoteTypes() {
    if (!this.transction_type) {
      // Get Quote Types
      this.quoteService.getQuoteTypes(1)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.transction_type = response.result.types[this.quote.type];
            }
          },
          (error) => {
            ;
          }
        );
    }
  }
    /*
  * Fetch Policy Reasons
  */
  policyReasonsList = [];
  getPolicyReasons() {
    //if (!this.policyReasonsList) {
    this.policyService.getPolicyMTAReasons(environment.SADDLERY_TACK_PROTECT_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            if (response.result.types) {
              this.policyReasonsList = response.result.types;
              let reasons = response.result.types.filter(x => x.id == this.quote.mta_reason_id);
              if (reasons.length > 0) {
                this.policyReason = reasons[0].reasons;
              }
            }
          }
        },
        (error) => {
          ;
        }
      );
  }
}
